module.exports = __webpack_public_path__ + "static/img/logo.34e79a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 305
// module chunks = 1